import { SOCKET_NEW_BLOCK } from "../../actions/addresses";

const defaultState = { SocketConnection: "" };
const SocketConnectionReducer = (state = defaultState, action) => {
  switch (action.type) {
    case SOCKET_NEW_BLOCK:
      return { ...state, SocketConnection: action.socketConnection };
    default:
      return state;
  }
};
export default SocketConnectionReducer;
